import React from 'react';
import UserContext from '../../components/common/UserContext';
import {Theme} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import AdUploader from './AdUploader';
import {makeStyles} from '@material-ui/core';
import {useState, useEffect} from 'react';

type UUID = string;

export type Props = {
  adFileKey: UUID,
  isOpen: boolean,
  onClose?: () => void
};

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    position: 'absolute',
    width: '33%',
    minWidth: 500,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}));

const UploadModal: React.FC<Props> = props => {
  const {apiToken} = React.useContext(UserContext);
  const [isOpen, setIsOpen] = useState(props.isOpen);
  const classes = useStyles();

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  function exit(): void {
    setIsOpen(false);
    if (props.onClose) { props.onClose(); }
  }

  return (
    <Modal
      open={isOpen}
      onClose={exit}
      className={classes.modal}
    >
      <div className={classes.paper}>
        <AdUploader
          adFileKey={props.adFileKey}
          userIdToken={apiToken || 'unknown-token'}
          onDone={exit}
        />
        <div className={classes.buttons}>
          <Button onClick={exit} className={classes.button}>Cancel</Button>
        </div>
      </div>
    </Modal>
  );
};
export default UploadModal;
